import { barkApi } from "@bark/bark-core";

/**
 * @typedef WalletOptions
 * @prop {Boolean} enableWallets
 * @prop {PaymentRequestOptions} paymentOptions
 */

/**
 * @param {Boolean} enableWallets
 * @param {PaymentRequestOptions} options
 * @return {WalletOptions}
 */
export const generateWalletOptions = (enableWallets, options = {}) => {
	const {
		label,
		amount,
		isUpsell,
		cpId,
		userId,
		nResponses,
		code,
		projectId,
		packType,
		onWalletPaymentComplete,
		onError,
		disableWallets,
	} = options;

	if (enableWallets && amount === undefined) {
		const error = new Error('Expected to enable wallets but no amount passed');
		console.error(error);
		window.bugsnagClient && window.bugsnagClient.notify(error);
		enableWallets = false;
	}

	return {
		enableWallets,
		paymentOptions: {
			label,
			amount,
			isUpsell,
			cpId,
			userId,
			nResponses,
			code,
			projectId,
			packType,
			onWalletPaymentComplete,
			onError,
			disableWallets,
		}
	}
}

export const setDefaultPaymentMethod = async (userId, paymentMethodId) => {
	return barkApi(
		`/user/${userId}/billing/payment-method/default`,
		{
			payment_method_id: paymentMethodId,
		},
		null,
		null,
		'POST',
	);
};
